import React, { Component } from "react";
import _ from "lodash";
import {
  editBooth,
  showBoothEditor,
  updateBooth,
  addNewBooth,
} from "InteractiveMapAction";
import { connect } from "react-redux";
import ResizableRect from "react-resizable-rotatable-draggable";

import "../modal.scss";

class ResizableBooth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldX: props.booth.location_x,
      oldY: props.booth.location_y,
      newX: props.booth.location_x,
      newY: props.booth.location_y,
      height:
        props.booth.location_height !== 0 ? props.booth.location_height : 50,
      width: props.booth.location_width !== 0 ? props.booth.location_width : 50,
      top: 0,
      left: 0,
    };
  }

  onLocationClick = (e) => {
    // e.preventDefault();
    if (this.props.toAddNewBooth) {
      this.props.showBoothEditor(true);
    } else {
      this.props.editBooth(this.props.booth);
    }
  };

  handleResize = (style, isShiftKey, type) => {
    // type is a string and it shows which resize-handler you clicked
    // e.g. if you clicked top-right handler, then type is 'tr'
    let { top, left, width, height } = style;
    top = Math.round(top);
    left = Math.round(left);
    width = Math.round(width);
    height = Math.round(height);

    this.setState({ top, left, width, height });
  };

  handleResizeDone = (style, isShiftKey, type) => {
    let { top, left, width, height } = this.state;

    var updatedBooth = {
      ...this.props.booth,
      location_width: width,
      location_height: height,
      location_x: left,
      location_y: top,
    };
    this.updateBooth(updatedBooth);
  };

  handleDrag = (deltaX, deltaY) => {
    //debugger;
    let x = this.state.newX + deltaX;
    let y = this.state.newY + deltaY;

    this.setState({
      newX: x,
      newY: y,
    });
  };

  handleDragEnd = (e) => {
    if (
      this.state.oldX == this.state.newX &&
      this.state.oldY == this.state.newY
    ) {
      // Click
      this.onLocationClick();
    } else {
      // Drag
    }

    this.setState({
      oldX: this.state.newX,
      oldY: this.state.newY,
    });

    var updatedBooth = {
      ...this.props.booth,
      location_x: this.state.newX,
      location_y: this.state.newY,
    };
    this.updateBooth(updatedBooth);
  };

  updateBooth(booth) {
    //Check if booth created on server to update in server
    if (_.startsWith(booth.locationid, "booth")) {
      //Not stored in server, update locally
      this.props.addNewBooth(booth);
    } else {
      var boothToUpdate = { resource: [booth] };
      this.props.updateBooth(
        this.props.session,
        boothToUpdate,
        this.props.selectedMap.interactivemapid,
        () => {},
        () => {}
      );
    }
  }

  render() {
    var { booth } = this.props;
    var { newX, newY, height, width } = this.state;

    var x = newX; //-offset.x;
    var y = newY; //-offset.y;

    var cssstyle = {
      left: x + 1,
      top: y + 1,
      height: height,
      width: width,
      position: "absolute",
      background: booth.color,
      opacity: 0.6,
    };

    var cssstyle1 = {
      width: width,
      height: height,
      left: x,
      top: y,
      position: "absolute",
      border: "2px solid" + booth.color,
    };

    return (
      <div>
        <div style={cssstyle} />
        <div style={cssstyle1} />

        <ResizableRect
          left={x}
          top={y}
          width={width}
          height={height}
          // rotateAngle={rotateAngle}
          // aspectRatio={false}
          // minWidth={10}
          // minHeight={10}
          // zoomable="n, w, s, e, nw, ne, se, sw"
          zoomable="nw, ne, se, sw"
          // rotatable={true}
          // onRotateStart={this.handleRotateStart}
          // onRotate={this.handleRotate}
          // onRotateEnd={this.handleRotateEnd}
          // onResizeStart={this.handleResizeStart}
          onResize={this.handleResize}
          onResizeEnd={this.handleResizeDone}
          // onDragStart={this.handleDragStart}
          onDrag={this.handleDrag}
          onDragEnd={this.handleDragEnd}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    toAddNewBooth: state.addEditBooth.toAddNewBooth,
    selectedMap: state.selectediMap,
  };
}

export default connect(mapStateToProps, {
  editBooth,
  showBoothEditor,
  updateBooth,
  addNewBooth,
})(ResizableBooth);
